export default {
    title: 'Welcome to your profile',
    yourProfile: 'Your Profile',
    profileVisitors: 'Profile visitors',
    sentMessages: 'Sent messages',
    receivedMessages: 'Received messages',
    membershipTitle: 'Do you want to be more popular?',
    membershipText: "Now you can upgrade your membership...Don't wait click the key and be the most popular on the website",
    likesReceivedTitle: 'Number of likes you got',
    likesReceivedText: 'people like your profile',
    numberOfLikes: 'Number of people who like you: ',
    likesMadeTitle: 'Number of likes you made',
    likesMadeText: 'You like %{count} people',
    editProfile: 'Edit profile',
    uploadImages: 'Upload images',
    blocksMade: 'Number of accounts you blocked',
    blocksReceived: 'Number of accounts that blocked you',
    blockedUsers: 'Blocked users',
    blockedUsersText: 'Number of users you blocked',
    profilePictures: 'Your profile pictures',
    changeProfilePictures: 'Change your profile pictures. You may have up to 4.',
    removePicture: 'Remove Picture',
    changePicture: 'Change picture'
}
